/* eslint-disable @typescript-eslint/only-throw-error -- TanStack Router requires throwing redirect() */
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/app/admin/")({
  beforeLoad: () => {
    throw redirect({ to: "/app/admin/analytics" });
  },
});
